export const formatNotionPageId = (pageId?: string): string | undefined =>
  pageId?.replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w+)/g, '$1-$2-$3-$4-$5')

export const formatNotionUrl = (url: string): string => {
  const cut = url.lastIndexOf('-')
  const urlToPageId = url
    .split('')
    .splice(cut + 1, 32)
    .join('')
    .replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w+)/g, '$1-$2-$3-$4-$5')
  return urlToPageId
}
